import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faCircleCheck, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import logoPemprov from '../../../assets/images/logo-provkalsel.png'
import headerImg from '../../../assets/images/header.webp'

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-slate-900 via-blue-950 to-blue-900">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 -left-40 w-80 h-80 bg-indigo-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/3 w-64 h-64 bg-blue-400/5 rounded-full blur-2xl" />
        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-5"
          style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
      </div>

      {/* Right: hero image as background */}
      <div className="absolute inset-y-0 right-8 w-1/3 hidden lg:flex items-center justify-center pointer-events-none translate-x-0">
        <img
          src={headerImg}
          alt=""
          className="w-3/4 object-contain opacity-90 -translate-x-52"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 lg:py-40 w-full">
        <div className="max-w-2xl">
        <div>
          {/* Badge */}
          {/* Official badge */}
          <div className="inline-flex items-center gap-3 bg-white/5 border border-white/10 text-blue-200 text-xs font-semibold px-4 py-2.5 rounded-full mb-8">
            <img src={logoPemprov} className="h-6 w-auto" alt="Pemprov Kalsel" />
            <span className="w-px h-4 bg-white/20" />
            <span className="uppercase tracking-wider">Pemerintah Daerah Provinsi Kalimantan Selatan</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight tracking-tight">
            Suarakan Kebenaran,{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-cyan-300">
              Wujudkan Pemerintahan
            </span>{' '}
            yang Bersih
          </h1>

          <p className="mt-6 text-lg text-blue-100/80 leading-relaxed max-w-2xl">
            Whistleblowing System (WBS) adalah kanal resmi dan aman untuk melaporkan dugaan pelanggaran, korupsi, serta penyimpangan di lingkungan Pemerintah Daerah Provinsi Kalimantan Selatan.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href="/register"
              className="inline-flex items-center gap-2 px-8 py-4 bg-blue-500 hover:bg-blue-400 text-white font-bold rounded-xl shadow-lg shadow-blue-900/40 transition-all hover:scale-105 active:scale-100">
              <FontAwesomeIcon icon={faBullhorn} className="w-5 h-5" />
              Buat Laporan Sekarang
            </a>
            <a href="/#cara-kerja"
              className="inline-flex items-center gap-2 px-8 py-4 border border-blue-400/30 hover:border-blue-300/60 text-blue-100 hover:text-white font-semibold rounded-xl transition-all hover:bg-white/5">
              Pelajari Cara Kerja
              <FontAwesomeIcon icon={faChevronDown} className="w-4 h-4" />
            </a>
          </div>

          {/* Trust badges */}
          <div className="mt-12 flex flex-wrap gap-6 text-sm text-blue-200/70">
            {['Dijamin Anonim', 'Terenkripsi', 'Dilindungi Hukum'].map(badge => (
              <span key={badge} className="flex items-center gap-2">
                <FontAwesomeIcon icon={faCircleCheck} className="w-4 h-4 text-green-400" />
                {badge}
              </span>
            ))}
          </div>
        </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </section>
  )
}
